import { Component } from '@theme/component';
class GGHomeStory extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (this.revealObserver || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    this.revealObserver = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        this.revealObserver.unobserve(entry.target);
        if (!entry.target.contains(document.activeElement)) entry.target.animate([{ opacity: .8, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 420, easing: 'ease-out' });
      }
    }, { threshold: .12 });
    this.querySelectorAll('[data-home-reveal]').forEach((node) => this.revealObserver.observe(node));
  }
  disconnectedCallback() {
    this.revealObserver?.disconnect();
    this.revealObserver = null;
    super.disconnectedCallback();
  }
}
if (!customElements.get('gg-home-story')) customElements.define('gg-home-story', GGHomeStory);
